import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isOnlySponsored } from '../../../../../config/report-predicates/isOnlySponsored';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import * as FIELDS from '../../fields';
import {
    DATE,
    CVR,
    AVERAGE_CPC,
    CONVERSIONS,
    CONVERSIONS_CLICKS,
    CONVERSIONS_VIEWS,
    CVR_CLICKS,
    CVR_VIEWS,
} from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { CAMPAIGN_HISTORY_REPORT_ID } from './campaignHistoryReportId';
import columnDefinitions from './columnDefinitions';
import { graph } from './graph';
import { defaultColumns, customColumns } from './reportPresets';

export const campaignHistoryReportConfig = {
    id: CAMPAIGN_HISTORY_REPORT_ID,
    label: 'Changes History',
    permissions: [REPORT_PERMISSION.CAMPAIGN_HISTORY_VIEW],
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
        [FEATURE_FLAGS.SHOW_CAMPAIGN_HISTORY_REPORT]: 'true',
    },
    visibilityCondition: isOnlySponsored,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-history',
    graph,
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    sortMap: {
        [DATE.field]: 'date',
        [CVR.field]: 'cpaConversionRate',
        [AVERAGE_CPC.field]: 'cpc',
        [CONVERSIONS.field]: 'cpaActionsNum',
        [CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
    searchPlaceholderMsgId: 'app.reports.byCampaignHistory.search.placeholder',
    searchField: 'performer',
    footerColumnDef: [],
    isEmptyFooter: true,

    filters: [
        {
            id: FILTER_TYPE.HISTORY_LOG_ACTIVITY_CODE_TYPE,
            permissions: ['ADS_CONSOLE_CAMPAIGN_HISTORY_FILTERS'],
            multiSelect: true,
            minVisibleCount: 4,
        },
    ],
};
